import React, { useState, useEffect } from "react";
import { useEditorContext } from "@/src/contexts/editorContext";
import QuarkleLoader from "@/src/components/QuarkleLoader";

function Loading() {
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [delayComplete, setDelayComplete] = useState(false);
  const { isStudioLoading } = useEditorContext();
  const loadingTime = isStudioLoading ? 5 : 0.1;

  useEffect(() => {
    const timer = setInterval(
      () => {
        setLoadingProgress((prevProgress) => {
          if (prevProgress < 100) {
            return prevProgress + 1;
          } else if (prevProgress === 100 && !delayComplete) {
            setTimeout(() => setDelayComplete(true), 100);
            return prevProgress;
          } else if (prevProgress === 100 && delayComplete && !isStudioLoading) {
            return 101;
          }
          return prevProgress;
        });
      },
      (loadingTime * 1000) / 100,
    );
    return () => clearInterval(timer);
  }, [isStudioLoading, delayComplete, loadingTime]);

  if (loadingProgress >= 101) return null;

  return (
    <div
      className="qk-editor qk-paper-bg absolute inset-0 flex flex-col items-center justify-center"
      style={{ background: "var(--qk-paper)", color: "var(--qk-ink)" }}
    >
      <div className="flex w-[min(24rem,90vw)] flex-col items-center gap-4">
        <QuarkleLoader size={120} />
        <div className="flex flex-col items-center gap-1">
          <span className="qk-caps" style={{ color: "var(--qk-muted)" }}>
            one moment
          </span>
          <h1
            style={{
              fontFamily: "'Gambarino', 'DM Serif Display', serif",
              fontStyle: "italic",
              fontSize: 22,
              color: "var(--qk-ink)",
              letterSpacing: "-0.01em",
            }}
          >
            preparing your workspace
          </h1>
        </div>
        <div
          className="relative h-[6px] w-full overflow-hidden rounded-full"
          style={{
            background: "var(--qk-rule-soft)",
            border: "1px solid var(--qk-rule)",
          }}
        >
          <div
            className="h-full rounded-full transition-all duration-300"
            style={{
              width: `${loadingProgress}%`,
              background: "var(--qk-ink)",
            }}
          />
        </div>
        <div className="flex w-full items-center justify-between">
          <span className="qk-mono" style={{ fontSize: 10, letterSpacing: "0.08em", color: "var(--qk-muted)" }}>
            {String(loadingProgress).padStart(3, "0")}%
          </span>
          <span className="qk-hand" style={{ fontSize: 14, color: "var(--qk-ink-2)" }}>
            shelf almost ready
          </span>
        </div>
      </div>
    </div>
  );
}

export default Loading;
